import React from "react";
import { graphql } from "gatsby";
import Layout from "../components/Layout";
import ReactMarkdown from "react-markdown";

export class PageTemplate extends React.Component {
  render() {
    const {
      page: {
        rawMarkdownBody,
        frontmatter: { docs }
      }
    } = this.props;
    return (
      <>
        <ReactMarkdown
          escapeHtml={false}
          className="about-description"
          source={rawMarkdownBody}
        />
        {docs &&
          docs.map(({ file, description }) => {
            return (
              <a
                target="_blank"
                rel="noopener noreferrer"
                href={file}
                key={file}
              >
                {description}
              </a>
            );
          })}
      </>
    );
  }
}

function LazyComponent({ component, ...props }) {
  const Component = require(`../components/${component}.js`);
  if (Component) {
    return <Component.default {...props} />;
  }
  return null;
}

const SeparatePage = props => {
  const { frontmatter, rawMarkdownBody } = props.data.page;
  return (
    <Layout title={frontmatter.title} sidebar={props.pageContext.sidebar}>
      <PageTemplate page={{ frontmatter, rawMarkdownBody }} />
      {frontmatter.customComponent ? (
        <LazyComponent component={frontmatter.customComponent} {...props} />
      ) : null}
    </Layout>
  );
};

export default SeparatePage;

export const separatePageQuery = graphql`
  query($slug: String!) {
    page: markdownRemark(fields: { slug: { eq: $slug } }) {
      frontmatter {
        title
        customComponent
        docs {
          file
          description
        }
      }
      html
      rawMarkdownBody
    }
  }
`;
